/**
 * Fur & Far exit-intent popup.
 * Soft browse reminder vs cart reminder. Once per session.
 * Desktop: mouse leave toward browser chrome.
 * Mobile: after product/cart engagement, then idle or leave-intent nav.
 * Cool-down after launch/welcome popups so they do not stack.
 * The homepage keeps a single overlay (the welcome signup), so this popup
 * does not arm there.
 */
(function () {
  'use strict';

  var WELCOME_MARK_KEY = 'ff-welcome-popup-closed-at';
  var ENGAGED_KEY = 'ff-exit-engaged';
  var LAUNCH_STORAGE_PREFIX = 'ff-launch-weekend-popup';

  function boot() {
    var root = document.querySelector('[data-ff-exit-popup]');
    if (!root || root.getAttribute('data-ff-exit-bound') === '1') return;
    root.setAttribute('data-ff-exit-bound', '1');

    var storageKey = root.getAttribute('data-storage-key') || 'ff-exit-intent';
    var postStorageKey = root.getAttribute('data-post-storage-key') || 'ff-exit-intent-free-ship-100';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var cooldownMs = parseInt(root.getAttribute('data-cooldown-ms') || '90000', 10);
    var idleMs = parseInt(root.getAttribute('data-idle-ms') || '45000', 10);
    var pageType = root.getAttribute('data-page-type') || '';
    var cartCount = parseInt(root.getAttribute('data-cart-count') || '0', 10);
    var isPost =
      root.getAttribute('data-ff-mode') === 'post' ||
      (window.FurFarLaunchWeekend &&
        typeof window.FurFarLaunchWeekend.phase === 'function' &&
        window.FurFarLaunchWeekend.phase() === 'ended');

    function activeStorageKey() {
      return isPost ? postStorageKey : storageKey;
    }

    var overlay = root.querySelector('[data-ff-exit-overlay]');
    var dialog = root.querySelector('[data-ff-exit-dialog]');
    var closeBtn = root.querySelector('[data-ff-exit-close]');
    var dismissBtn = root.querySelector('[data-ff-exit-dismiss]');
    var cta = root.querySelector('[data-ff-exit-cta]');
    var badgeEl = root.querySelector('[data-ff-exit-badge]');
    var headingEl = root.querySelector('[data-ff-exit-heading]');
    var bodyEl = root.querySelector('[data-ff-exit-body]');
    var offerLabelEl = root.querySelector('[data-ff-exit-offer-label]');
    var offerTextEl = root.querySelector('[data-ff-exit-offer-text]');
    var offerEndsEl = root.querySelector('[data-ff-exit-offer-ends]');
    var noteEl = root.querySelector('[data-ff-exit-note]');

    var isOpen = false;
    var armed = false;
    var shown = false;
    var previouslyFocused = null;
    var idleTimer = null;
    var pageReadyAt = Date.now();

    function readSession(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    function writeSession(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {}
    }

    function alreadyShown() {
      return readSession(activeStorageKey()) === '1';
    }

    function markShown() {
      writeSession(activeStorageKey(), '1');
      shown = true;
    }

    function markEngaged() {
      writeSession(ENGAGED_KEY, '1');
    }

    function hasEngaged() {
      return readSession(ENGAGED_KEY) === '1' || pageType === 'product' || cartCount > 0;
    }

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 749px), (hover: none)').matches;
    }

    function otherPopupOpen() {
      var launch = document.querySelector('[data-ff-launch-popup].is-open');
      if (launch) return true;
      if (document.body.classList.contains('ff-launch-popup-open')) return true;
      if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) return true;
      if (document.body.classList.contains('ff-welcome-popup-open')) return true;
      if (window.FurFarWelcomePopup && typeof window.FurFarWelcomePopup.isOpen === 'function') {
        if (window.FurFarWelcomePopup.isOpen()) return true;
      }
      var welcome = document.querySelector('div[role="dialog"][aria-label="POPUP Form"]');
      if (welcome) {
        var welcomeStyle = window.getComputedStyle(welcome);
        if (
          welcomeStyle.display !== 'none' &&
          welcomeStyle.visibility !== 'hidden' &&
          welcome.getAttribute('aria-hidden') !== 'true'
        ) {
          return true;
        }
      }
      return false;
    }

    function coolDownActive() {
      var closedAt = parseInt(readSession(WELCOME_MARK_KEY) || '0', 10);
      if (closedAt && Date.now() - closedAt < cooldownMs) return true;
      // Also wait a bit after first paint so launch popup can claim the first moment
      if (Date.now() - pageReadyAt < Math.min(cooldownMs, 20000)) return true;
      return false;
    }

    function launchAlreadyHandled() {
      // If launch popup was dismissed this session, respect cool-down from that moment
      try {
        for (var i = 0; i < sessionStorage.length; i++) {
          var key = sessionStorage.key(i);
          if (key && key.indexOf(LAUNCH_STORAGE_PREFIX) === 0 && sessionStorage.getItem(key) === '1') {
            return true;
          }
        }
      } catch (e) {}
      return false;
    }

    function refreshCartCount(done) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') {
            cartCount = cart.item_count;
            root.setAttribute('data-cart-count', String(cartCount));
          }
          if (done) done();
        })
        .catch(function () {
          if (done) done();
        });
    }

    function applyCopy() {
      var hasItems = cartCount > 0;
      var campaign = window.FurFarLaunchWeekend;
      if (campaign && typeof campaign.phase === 'function' && campaign.phase() === 'ended') {
        isPost = true;
      }
      var endsLine = isPost ? '' : root.getAttribute('data-offer-ends') || 'Ends 20 September at 11:59pm';
      var offerLabel = isPost
        ? root.getAttribute('data-post-offer-label') || 'Free shipping'
        : root.getAttribute('data-offer-label') || 'Launch Offer';
      var offerText = isPost
        ? root.getAttribute('data-post-offer-text') || 'Free Australian shipping on orders over $100'
        : root.getAttribute('data-offer-text') || 'Free shipping on all orders';
      if (hasItems) {
        badgeEl.textContent = root.getAttribute('data-cart-badge') || "DON'T MISS OUT";
        headingEl.textContent = root.getAttribute('data-cart-heading') || 'Your cart misses you';
        bodyEl.textContent = root.getAttribute('data-cart-body') || "You've still got something waiting for you.";
        offerLabelEl.textContent = offerLabel;
        offerTextEl.textContent = offerText;
        noteEl.textContent = isPost
          ? root.getAttribute('data-post-cart-offer') ||
            'Complete your order and enjoy free Australian shipping over $100.'
          : root.getAttribute('data-cart-offer-text') ||
            'Complete your order before you go and enjoy free shipping on all orders.';
        cta.textContent = root.getAttribute('data-cart-cta') || 'TAKE ME BACK TO MY CART';
        dismissBtn.textContent = root.getAttribute('data-cart-dismiss') || 'Continue browsing';
      } else {
        badgeEl.textContent = root.getAttribute('data-soft-badge') || 'STILL HERE?';
        headingEl.textContent = root.getAttribute('data-soft-heading') || 'Wait — forgotten something?';
        bodyEl.textContent =
          root.getAttribute('data-soft-body') || 'Your next adventure might still be sitting in your cart.';
        offerLabelEl.textContent = offerLabel;
        offerTextEl.textContent = offerText;
        noteEl.textContent =
          root.getAttribute('data-welcome-text') ||
          'Already joined the pack? Your 10% welcome discount may also apply.';
        cta.textContent = root.getAttribute('data-soft-cta') || 'RETURN TO MY CART';
        dismissBtn.textContent = root.getAttribute('data-soft-dismiss') || "No thanks, I'm just browsing.";
      }
      if (offerEndsEl) {
        offerEndsEl.textContent = endsLine;
        offerEndsEl.hidden = !endsLine;
      }
      cta.setAttribute('href', cartUrl);
    }

    function getFocusable() {
      return Array.prototype.slice
        .call(
          dialog.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(function (el) {
          return !el.hasAttribute('disabled') && el.offsetParent !== null;
        });
    }

    function onKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        dismiss();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function canShow() {
      if (pageType === 'index') return false;
      if (shown || alreadyShown() || isOpen) return false;
      // After Launch Weekend, keep showing with free-shipping-over-$100 copy.
      var campaign = window.FurFarLaunchWeekend;
      if (campaign && typeof campaign.phase === 'function' && campaign.phase() === 'ended') {
        isPost = true;
      }
      if (otherPopupOpen()) return false;
      if (coolDownActive() && !launchAlreadyHandled()) return false;
      if (coolDownActive() && launchAlreadyHandled()) {
        // Launch was dismissed; still honour remaining cool-down from welcome mark if set
        var closedAt = parseInt(readSession(WELCOME_MARK_KEY) || '0', 10);
        if (closedAt && Date.now() - closedAt < cooldownMs) return false;
        // If launch dismissed but no welcome mark, require short gap from page ready
        if (!closedAt && Date.now() - pageReadyAt < 15000) return false;
      }
      if (isMobile() && !hasEngaged()) return false;
      return true;
    }

    function openPopup() {
      if (!canShow()) return;
      applyCopy();
      previouslyFocused = document.activeElement;
      root.hidden = false;
      root.classList.add('is-open');
      document.body.classList.add('ff-exit-popup-open');
      isOpen = true;
      markShown();
      window.setTimeout(function () {
        if (closeBtn) closeBtn.focus();
      }, 0);
      document.addEventListener('keydown', onKeydown);
    }

    function closePopup(navigateHref) {
      if (!isOpen) {
        if (navigateHref) window.location.href = navigateHref;
        return;
      }
      isOpen = false;
      root.classList.remove('is-open');
      root.hidden = true;
      document.body.classList.remove('ff-exit-popup-open');
      document.removeEventListener('keydown', onKeydown);
      writeSession(WELCOME_MARK_KEY, String(Date.now()));
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
      previouslyFocused = null;
      if (navigateHref) window.location.href = navigateHref;
    }

    function dismiss() {
      markShown();
      closePopup();
    }

    function tryOpen() {
      if (!canShow()) return;
      refreshCartCount(function () {
        openPopup();
      });
    }

    function onMouseOut(event) {
      if (!armed || isMobile()) return;
      if (event.clientY > 12) return;
      if (event.relatedTarget || event.toElement) return;
      tryOpen();
    }

    function resetIdle() {
      if (!isMobile() || !armed) return;
      if (idleTimer) window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () {
        tryOpen();
      }, idleMs);
    }

    function onNavIntent(event) {
      if (!armed || !isMobile()) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
      // Leaving product/collection toward home or external-ish routes
      if (href.indexOf('/cart') === 0 || href.indexOf(cartUrl) === 0) return;
      if (pageType === 'product' || hasEngaged()) {
        // Soft intercept once — show popup instead of navigating away immediately
        if (canShow() && (href === '/' || href.indexOf('/collections') === 0 || href.indexOf('http') === 0)) {
          event.preventDefault();
          tryOpen();
        }
      }
    }

    function arm() {
      if (armed || alreadyShown()) return;
      armed = true;
      document.addEventListener('mouseout', onMouseOut);
      if (isMobile()) {
        ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (evt) {
          window.addEventListener(evt, resetIdle, { passive: true });
        });
        document.addEventListener('click', onNavIntent, true);
        resetIdle();
      }
    }

    // Engagement signals for mobile eligibility
    if (pageType === 'product' || pageType === 'cart' || cartCount > 0) {
      markEngaged();
    }
    document.addEventListener(
      'click',
      function (event) {
        var el = event.target && event.target.closest ? event.target.closest('[href*="/products/"], form[action*="/cart"], [name="add"]') : null;
        if (el) markEngaged();
      },
      true
    );

    // When launch popup closes, start cool-down clock
    document.addEventListener('click', function (event) {
      var launchClose =
        event.target &&
        event.target.closest &&
        event.target.closest('[data-ff-launch-close], [data-ff-launch-overlay], [data-ff-launch-cta], [data-ff-launch-copy]');
      if (launchClose) {
        writeSession(WELCOME_MARK_KEY, String(Date.now()));
      }
    });

    // Observe launch popup leaving open state
    var launchRoot = document.querySelector('[data-ff-launch-popup]');
    if (launchRoot && window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (launchRoot.hidden || !launchRoot.classList.contains('is-open')) {
          if (!readSession(WELCOME_MARK_KEY)) {
            writeSession(WELCOME_MARK_KEY, String(Date.now()));
          }
        }
      });
      obs.observe(launchRoot, { attributes: true, attributeFilter: ['hidden', 'class'] });
    }

    if (alreadyShown()) return;
    if (pageType === 'index') return;

    // Arm after cool-down so we do not fight the launch/welcome popup
    window.setTimeout(arm, Math.min(cooldownMs, 25000));
    // If launch never appears, still arm
    window.setTimeout(arm, cooldownMs);

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        dismiss();
      });
    }
    if (overlay) {
      overlay.addEventListener('click', function () {
        dismiss();
      });
    }
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function (event) {
        event.preventDefault();
        dismiss();
      });
    }
    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        markShown();
        closePopup(cta.getAttribute('href') || cartUrl);
      });
    }
  }

  // Expose helper so welcome/Klaviyo scripts can mark cool-down if desired
  window.FurFarExitIntent = {
    markWelcomeClosed: function () {
      try {
        sessionStorage.setItem(WELCOME_MARK_KEY, String(Date.now()));
      } catch (e) {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
